module.exports = __webpack_public_path__ + "static/media/galerija_2017 (39).fe5c9a3e.jpg";